module.exports = __webpack_public_path__ + "img/S1M9_new.8d03de49.jpg";